import { Trans } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'

import { createDownloadImages, getLocalizedIndexImage } from './localizedImages'

import LazyImage from '@/components/LazyImage'
import { useLocale } from '@/hooks/routes'
export const CreateDownload: React.FC = () => {
  const locale = useLocale()
  const src = getLocalizedIndexImage(
    locale,
    '/images/index/download-qrcode.png',
    createDownloadImages,
  )

  return (
    <div className='relative'>
      <LazyImage fill src={'/images/index/create-download-bg.png'} alt={''} />

      <div className='relative mx-auto flex max-w-[1072px] flex-col items-center gap-12 lg:flex-row'>
        <div className='flex flex-1 flex-col items-center gap-4 px-4 lg:items-start lg:px-0'>
          <H2 className='mx-auto pt-1 text-left lg:max-w-[880px] lg:pt-9'>
            <Trans>Create Music Anywhere With Tad AI</Trans>
          </H2>
          <p className='text-f-other-10 pt-2 text-lg lg:pt-3 lg:text-xl'>
            <Trans>
              Experience the power of AI music generation with the Tad AI mobile
              app. Download it now and start generating original songs instantly
              on your phone!
            </Trans>
          </p>
          <a
            href='https://apps.apple.com/us/app/tad-ai-music-generator/id6745503123'
            target='_blank'
            rel='noopener noreferrer'
          >
            <LazyImage
              className='mt-3 cursor-pointer'
              width={168}
              height={56}
              src={'/images/index/app-store.png'}
              alt={''}
            />
          </a>
        </div>
        <LazyImage width={480} height={600} src={src} alt={''} />
      </div>
    </div>
  )
}
